import {PlanDetails} from "./PlanDetails";
import {InsuredDetails} from "./InsuredDetails";
import {OwnerDetails} from "./OwnerDetails";
import {Beneficiary} from "./Beneficiary";
import {PendingPolicy} from "./PendingPolicy";
import {InforcePolicy} from "./InforcePolicy";

export class ApplicationData {
    planDetails: PlanDetails;
    insuredDetails: InsuredDetails;
    ownerDetails: OwnerDetails;
    //TODO: Change primaryBeneficiary and contingentBeneficiary to array of them since we can have multiple primary and contingent beneficiaries.
    primaryBeneficiary: Beneficiary;
    contingentBeneficiary: Beneficiary;
    applicationDataComments: string;
    applicationId: string;
    beneficiaries: Beneficiary[];
    pendingPolicies: PendingPolicy[];
    inforcePolicies: InforcePolicy[];
    isHipaaSignatureCompleted: boolean = false;
    isDriverLicenseUploaded: boolean = false;

    constructor() {
        this.planDetails = new PlanDetails()
        this.insuredDetails = new InsuredDetails();
        this.ownerDetails = new OwnerDetails();
        this.primaryBeneficiary = new Beneficiary();
        this.contingentBeneficiary = new Beneficiary();
        this.applicationDataComments = '';
        this.applicationId = '';
        this.beneficiaries = [];
        this.pendingPolicies = [];
        this.inforcePolicies = [];
    }
}
